import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { bonuses, totalBonusValue, usd } from '../data/content';
import { Eyebrow, Highlight, SectionTitle } from './ui/Section';
export function Bonuses() {
  return <section className="border-t border-slate-200 bg-slate-50 px-4 py-12 md:py-16" data-id="element-20" data-mp="au1rofrdu2f7">
      <div className="mx-auto max-w-6xl" data-id="element-21" data-mp="fteex1m61bib">
        <Eyebrow data-id="element-22" data-mp="fsbnmskxl71v">
          <span className="inline-flex items-center gap-2" data-id="element-23" data-mp="frtono6vweq9">
            <GiftIcon className="h-4 w-4" data-id="element-24" data-mp="1stww7o2rjpv" /> 5 practical bonuses always included
          </span>
        </Eyebrow>
        <SectionTitle data-id="element-25" data-mp="5xbhg929e11p">
          Plus, you get <Highlight data-id="element-26" data-mp="3o1v6yjq1s0r9">5 practical bonuses</Highlight>
        </SectionTitle>

        <div className="mt-8 grid gap-4 md:grid-cols-2 lg:grid-cols-3" data-id="element-27" data-mp="3o3y5js59n27l">
          {bonuses.map(bonus => <article key={bonus.number} className={`flex flex-col rounded-2xl border bg-white p-5 shadow-sm ${bonus.featured ? 'border-2 border-amber-400' : 'border-slate-200'}`} data-id="element-28" data-mp="1ma8m6zwr1238">
              <small className="w-fit rounded bg-amber-400 px-2 py-0.5 text-[11px] font-black uppercase tracking-wide text-blue-950" data-id="element-29" data-mp="3idwnnhlet8k6">
                {bonus.emoji} Bonus {bonus.number}
              </small>
              <h3 className="mt-3 text-lg font-black uppercase leading-tight text-blue-950" data-id="element-30" data-mp="3r6zyrj8l19bn">
                {bonus.name}
              </h3>
              <p className="mt-2 text-sm font-semibold leading-relaxed text-slate-600" data-id="element-31" data-mp="3n5y83qsqe5la">
                {bonus.description}
              </p>

              <div className="my-4 flex-1 space-y-4" data-id="element-32" data-mp="2ugr2y8yruhr2">
                {bonus.groups.map(group => <div key={group.label ?? group.items[0]} data-id="element-33" data-mp="38gs29jze1h4f">
                    {group.label && <p className="text-xs font-bold uppercase tracking-wide text-slate-500" data-id="element-34" data-mp="33gntyh8mvspa">
                        {group.label}
                      </p>}
                    {group.style === 'chips' ? <ul className="mt-2 flex flex-wrap gap-1.5" data-id="element-35" data-mp="iq59j6kpjng1">
                        {group.items.map(item => <li key={item} className="rounded-full bg-slate-100 px-2.5 py-0.5 text-xs font-semibold text-slate-700" data-id="element-36" data-mp="3cl0tx4b6gchu">
                            {item}
                          </li>)}
                      </ul> : <ul className="mt-2 space-y-1.5 text-sm font-semibold leading-snug text-slate-700" data-id="element-37" data-mp="2ttgdt1s8dwlb">
                        {group.items.map(item => <li key={item} className="flex gap-2" data-id="element-38" data-mp="32t3hxvcchgi2">
                            <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-yellow-700" data-id="element-39" data-mp="32rsclr3940ou" />
                            {group.style === 'quotes' ? `“${item}”` : item}
                          </li>)}
                      </ul>}
                  </div>)}
                {bonus.highlights && <div className="rounded-lg bg-amber-50 px-3 py-2.5" data-id="element-40" data-mp="27kjd9059cfm9">
                    {bonus.highlights.map(line => <p key={line} className="text-sm font-black text-blue-950" data-id="element-41" data-mp="22m828m387z2g">
                        {line}
                      </p>)}
                  </div>}
              </div>

              <div className="mt-auto flex items-center justify-between gap-3 border-t border-slate-200 pt-4 text-sm" data-id="element-42" data-mp="1tjywe9iwktve">
                <span className="font-semibold text-slate-500" data-id="element-43" data-mp="1omykvj3aayww">
                  Value: <s className="font-black text-slate-400" data-id="element-44" data-mp="1jt470wad1e5q">{usd(bonus.value)}</s>
                </span>
                <span className="rounded-full bg-emerald-700 px-3 py-1 text-xs font-black uppercase tracking-wide text-white" data-id="element-45" data-mp="1evlukvx4wgsz">
                  Included free today
                </span>
              </div>
            </article>)}

          <div className="flex flex-col items-center justify-center rounded-2xl bg-blue-950 p-6 text-center md:col-span-2 lg:col-span-1" data-id="element-46" data-mp="10vtavkk0z0ui">
            <p className="text-xs font-extrabold uppercase tracking-[.16em] text-amber-400" data-id="element-47" data-mp="30z3ud88bvht2">
              Total bonus value
            </p>
            <p className="mt-2 text-4xl font-black text-white/50 line-through decoration-red-500 decoration-4" data-id="element-48" data-mp="3518qcdm90qiv">
              {usd(totalBonusValue)}
            </p>
            <p className="mt-3 text-2xl font-black uppercase text-amber-400" data-id="element-49" data-mp="2w5j7occ6qa96">Free today</p>
            <p className="mt-2 text-sm font-semibold text-slate-300" data-id="element-50" data-mp="2h91xvpjn93oq">
              Included with CLEAR THE CLUTTER™ today.
            </p>
          </div>
        </div>
      </div>
    </section>;
}